// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"653":"videojs","818":"theoplayer"}[chunkId] || chunkId) + "." + {"653":"e45c6c10","787":"bcb7d9d6","818":"63e60195","878":"ea8607be"}[chunkId] + ".chunk.js";
};